<template>
<div style="position:absolute;left:0;top:0;width:fit-content;height:100%;">
    <div class="functionBar" v-drag @click="openDrawers($event)">目录</div>
    <el-drawer
        append-to-body
        title="so"
        :withHeader="false"
        :visible.sync="dialogDrawerBox"
        :size="drawerWidth"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        @open="get_subject_detail"
        >
        <div class="demo-drawer__content"  v-if="dialogDrawerBox">
            <div class="drawerLogHeader">
                <ul class="tabList">
                    <li v-for="(item,index) in leftList" @click="tabClick(item)" :class="{'active':leftListInd==item.id}" :key="index">{{item.title}}</li>
                </ul>
                <i class=" el-icon el-icon-close" @click="closeDrawer"></i>
            </div>
            <div class="drawerLogWrap">
                <div class="catalgBox" v-show="leftListInd == 0">
                    <div class="catalgTitle">{{subinfo.subtitle}}</div>
                    <ul>
                        <li  v-for="(item,index) in chaplist" :key="index">
                            <div class="chapterName">{{item.sctitle}}</div>
                            <ul>
                                <li v-for="(itema,indexa) in item.children" :key="indexa" :class="{'active':itema.sccid==sccid}" >
                                    <div @click="toStudyPage(itema)">
                                        <i v-if="itema.restype == 1" class="iconfont icon-shipin"></i>
                                        <i v-else-if="itema.restype == 2" class="iconfont icon-pdf11"></i>
                                        <i v-else-if="itema.restype == 3" class="iconfont icon-kaoshi"></i>
                                        <i v-else-if="itema.restype == 6" class="iconfont icon-jiangyi"></i>
                                        <i v-else-if="itema.restype == 7" class="iconfont icon-diannao1"></i>
                                        <span>{{itema.resname}}</span>
                                        <!-- 小锁图标 -->
                                        <i class="el-icon-lock lockIcon" v-show="itema.study_status==0"></i>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </el-drawer>
</div>
</template>
<script>
import {getAjax,postAjax } from '@/api/index.js';
import isMobile from '@/api/isMobile.js';
const clickoutside = {
    // 初始化指令
    bind(el, binding, vnode) {
        function documentHandler(e) {
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
                return false;
            }
            // 判断指令中是否绑定了函数
            if (binding.expression) {
                // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                binding.value(e);
            }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
    },
    update() {},
    unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
    },
};
export default {
    inject:['reload'],
    props:{
        srtype:{},
        srid:{},
        sccid:{},
        spaceid:{
            type:[String,Number],
            default:0
        },
        ispreview:{
            type:[Object,Boolean],
            default:null
        },
        types:{
            type:[String],
            default:'square'
        },
        hasNote:{
            type:[Boolean,String,Number],
            default:true
        },
        isdrop:{
            type:[Boolean,String,Number],
            default:false
        },
    },
    directives: {
        clickoutside,
        drag(el,bindings){
            var dragging = false;
            var boxX, boxY, mouseX, mouseY, offsetX, offsetY;
            var firstTime='',lastTime='';
            function getMouseXY(e){
                var x = 0, y = 0
                e = e || window.event

                if (e.pageX) {
                    x = e.pageX
                    y = e.pageY
                } else {
                    x = e.clientX + document.body.scrollLeft - document.body.clientLeft
                    y = e.clientY + document.body.scrollTop - document.body.clientTop
                }
                return {
                    x: x,
                    y: y
                }
            }
            el.onmousedown = function(e){
                el.setAttribute('data-flag',false)
                firstTime = new Date().getTime();
                dragging = true;
                boxX = el.offsetLeft
			    boxY = el.offsetTop

                // 获取鼠标所在的坐标
                mouseX = parseInt(getMouseXY(e).x)
                mouseY = parseInt(getMouseXY(e).y)

                // 鼠标相对元素左和上边缘的坐标
                offsetX = mouseX - boxX
                offsetY = mouseY - boxY
                document.onmousemove = function (e){
                   if (dragging){
                       el.style.cursor='move'
                       var x = getMouseXY(e).x - offsetX
                       var y = getMouseXY(e).y - offsetY
                        var width = el.parentNode.clientWidth - el.offsetWidth
                        var height = el.parentNode.clientHeight - el.offsetHeight
                        // min方法保证不会超过右边界，max保证不会超过左边界
                        x = Math.min(Math.max(0, x), width)
                        y = Math.min(Math.max(0, y), height)
                        // 给元素及时定位
                        // el.style.left = x + 'px'
                        el.style.top = y + 'px'
                   }
                }
                document.onmouseup = function(){
                   dragging = false
                   el.style.cursor='pointer'
                   lastTime = new Date().getTime();
                  if( (lastTime - firstTime) < 200){
                    el.setAttribute('data-flag',true)
                  }
                }
            }
        }
    },
    data(){
        return{
            dialogDrawerBox:false,
            leftList:[
                {title:this.$t('Catalog'), id:0,},
            ],
            leftListInd:0,
            subinfo:{},
            chaplist:[],
            fullWidth:0,
            drawerWidth:480,
            widths:isMobile()?20:8,
            paddingLeft:isMobile()?20:8,
        }
    },
    created(){

    },
    mounted(){
        this.fullWidth= `${document.documentElement.clientWidth}`;//默认值
         window.onresize = () => {
            return (() => {
            window.fullWidth = document.documentElement.clientWidth;
            this.fullWidth = window.fullWidth
            })()
        }
    },
    methods:{

        openDrawerHandle(index){
            this.leftListInd = index;
            if(this.dialogDrawerBox) return;
            this.dialogDrawerBox = true;

        },
        openDrawers(event){
            let isClick = event.currentTarget.getAttribute('data-flag');
            if(isClick !== 'true') {
                return false
            }
            this.dialogDrawerBox = true;
        },
        closeDrawer(){
            this.dialogDrawerBox = false;
        },
        tabClick(item){
            this.leftListInd = item.id;
        },
        get_subject_detail(){
            let  url = '/space/subject_detail';
            let  params = {subid:this.srid, spaceid:this.spaceid}
            postAjax(url,params).then(res=>{
                this.chaplist = res.data.chap;
                this.subinfo = res.data.subinfo;
            }).catch(err=>{})
        },

        //去学习详细
        toStudyPage(item){
            let ispreview = this.ispreview === true ||  this.ispreview === 'true' ||  this.ispreview == 1 ? 1 : 0
            if(item.sccid == this.sccid) return;
            // time_status 1:有效  2：课程的学习时间未开始  3：当前课程已过期
            if (this.subinfo.time_status != 1){
                this.$notify({title: this.$t('Prompt'), message: this.subinfo.time_status_text, type: 'warning', duration:2000});
                return  false ;//不允许学习
            }
            //状态判断   0、禁止学习  1、未作答 2、进行中 3、已完成  4、待统计（待审核） 5、驳回重做 ,
            if (item.study_status === 0){

                return  false ;//不允许学习

            }
            else if (item.study_status === 1 || item.study_status === 2 || item.study_status === 3  || item.study_status === 4 || item.study_status === 5){
                if (item.restype === 1){

                    this.$router.replace({path:`/courseVideo/${this.spaceid}/${item.subid}/${item.sccid}/${ispreview}`})

                }else if (item.restype === 2){

                    this.$router.replace({path:`/coursePDF/${this.spaceid}/${item.subid}/${item.sccid}/${ispreview}`})

                }else if (item.restype === 3){

                    if ( item.study_status === 3 ){

                        this.$router.replace({path:`/evaluationReport/${this.params.spaceid}/${item.subid}/${item.sccid}`})
                    }else if ( item.study_status === 4 ){

                      return ;
                    }else{

                        this.$router.replace({path:`/coursePaper/${this.spaceid}/${item.subid}/${item.sccid}/${ispreview}`})
                    }

                }else if (item.restype === 6){

                    this.$router.replace({path:`/courseHandouts/${this.spaceid}/${item.subid}/${item.sccid}/${ispreview}`})

                }else if (item.restype === 7){
                    if(isMobile()){
                        this.$message({
                            message:this.$t('Mobile terminal is not supported, please go to PC terminal operation!'), type:'warning'
                        })
                        return
                    }
                    var _href = `/courseTask/${this.spaceid}/${item.subid}/${item.sccid}/${ispreview}`
                    if(item.is_forever == 1){
                        const { href } = this.$router.resolve({_href});
                        window.open(href,'_blank');
                    }else{
                        this.$router.replace({path:_href})
                    }

                }
            }
            return true;

        },
        mouseOver(){
            if(!isMobile()){
                let catalogUlWidth = this.$refs.catalogUl.clientWidth;
                this.widths = catalogUlWidth + (isMobile()?20:8);
            }

        },
        mouseLeave(){
            if(!isMobile()){
                this.widths = (isMobile()?20:8);
            }

        },
        clickoutsideHandle(){
             if(isMobile()){
                this.widths = (isMobile()?20:8);
            }
        },
        clickHandle(){
            if(isMobile()){
                let catalogUlWidth = this.$refs.catalogUl.clientWidth;
                this.widths = catalogUlWidth + (isMobile()?20:8);
            }
        },
        changeFixed(fullWidth){
            if(fullWidth <= 768){
                this.drawerWidth = '95%';
            }else{
                this.drawerWidth = 480;
            }

        },
    },
    watch:{
        $route(to,from){
            this.reload()
        },
        fullWidth:function(val){
            if(!this.timer) {
            this.fullWidth = val
            this.changeFixed(this.fullWidth)
            this.timer = true
            let that = this
            setTimeout(function (){//频繁触发 resize 函数，会导致页面很卡
                that.timer = false
            },100)
            }
      },
    }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/homepage/learnSquare/drawerBox.scss';
</style>



// WEBPACK FOOTER //
// src/page/Common/coursePack/drawerBox.vue